export class SqlQueryExecutionResultColumn {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqlQueryExecutionResultColumn.attributeTypeMap;
    }
    constructor() {
    }
}
